<div class="flex items-center gap-4 bg-white rounded-xl border border-slate-100 shadow-sm px-4 py-3 hover:border-blue-200 transition-colors">
    <div class="shrink-0 bg-blue-50 text-blue-600 p-2.5 rounded-lg flex">
        <mat-icon>router</mat-icon>
    </div>

    <div class="flex-1 min-w-0">
        <p class="font-semibold text-slate-900 truncate">
            {{ assignment.masterDevice?.deviceName || 'Unknown Device' }}
        </p>
        <p class="text-xs text-slate-500">{{ assignmentTypeLabel }}</p>
    </div>

    <div class="shrink-0 flex items-center">
        <button mat-icon-button (click)="onEdit()" [disabled]="isDeleting" matTooltip="Edit Master Controller"
            class="text-slate-500 hover:text-blue-600">
            <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button (click)="onDelete()" [disabled]="isDeleting" matTooltip="Delete Assignment"
            class="text-slate-500 hover:text-red-600">
            @if (isDeleting) {
            <mat-spinner diameter="20"></mat-spinner>
            } @else {
            <mat-icon>delete</mat-icon>
            }
        </button>
    </div>
</div>
